import { withTheme } from '../../core/ThemeProvider';
import { responsiveStyles } from '../../core/utils/responsiveStyles';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import getFontFamily from '../../helpers/getFontFamily';

const getContentStyle = level => {
  switch (level) {
    case 0:
      return "counter(section) '. '";
    case 2:
      return "'(' counter(section, lower-alpha) ') '";
    case 3:
      return "'(' counter(section, lower-roman) ') '";
    default:
      return "counters(section, '.') ' '";
  }
};

const bodyLineHeights = { default: 1.75, compact: 1.5, medium: 1.3 };
const fontWeights = { thin: 'thin', regular: 'regular', bold: 'bold' };
const fontFamilyType = { primary: 'primary', secondary: 'secondary' };

const typeReset = {
  marginTop: 0,
  marginBottom: 0,
  fontWeight: 'unset',
  letterSpacing: 0,
  textRendering: 'optimizeLegibility',
  '-webkit-font-smoothing': 'antialiased'
};

const NumberListItem = withTheme(
  styled.li`
     ${({ coreTheme }) => ({
       ...typeReset,
       ...responsiveStyles(
         {
           fontSize: [16, 16, 16, 18, 18]
         },
         coreTheme
       ),
       fontFamily: getFontFamily({
         fontFamilyType:
           coreTheme.text?.fontFamilyType || fontFamilyType.secondary,
         fontWeight: fontWeights.regular,
         theme: coreTheme,
         typePreset: 'body'
       }),
       fontWeight: coreTheme.text?.body?.fontWeight || '',
       lineHeight: bodyLineHeights.default,
       letterSpacing: 0.18
     })}
    
    ${({ coreTheme }) =>
      coreTheme?.text?.body
        ? responsiveStyles(coreTheme?.text?.body, coreTheme)
        : {}}
    padding-top: ${({ coreTheme }) => coreTheme?.numberList?.paddingTop}px;
    color: ${({ coreTheme }) => coreTheme?.numberList?.colourText};
    display: table;

    &::before {
      display: table-cell;
      ${({ coreTheme, simple, level }) =>
        responsiveStyles(
          {
            width: simple
              ? coreTheme?.numberList?.simpleWidth
              : level === 3
              ? 32
              : coreTheme?.numberList?.complexWidth
          },
          coreTheme
        )}

      padding-right: ${({ coreTheme }) =>
        coreTheme?.numberList?.paddingRight}px;
      counter-increment: ${({ counterIncrement }) =>
        counterIncrement ? `section ${counterIncrement}` : 'section'};
      content: ${({ level }) => getContentStyle(level)};
    }
  `
);

NumberListItem.propTypes = {
  coreTheme: PropTypes.object.isRequired,
  simple: PropTypes.string.isRequired,
  level: PropTypes.number.isRequired,
  counterIncrement: PropTypes.number
};

Number.defaultProps = {
  counterIncrement: null
};

export default NumberListItem;
